import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { map, of, switchMap } from 'rxjs'

import { isFeatureAllowed } from '../config/feature-permission.config'
import { AuthService } from '../services/auth.service'
import { TrygroupDashboardSettingsService } from '../services/trygroup-dashboard-settings/trygroup-dashboard-settings.service'
import { UserStore } from '../stores/user.store'
import { hasTrygroupManagementRole } from './trygroup-dashboard-access'

export const trygroupMemberAnalysisGuard: CanActivateFn = (route) => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const userStore = inject(UserStore)
  const trygroupDashboardSettingsService = inject(
    TrygroupDashboardSettingsService,
  )
  const targetUserId = route.paramMap.get('userId')

  if (targetUserId == null) {
    router.navigate(['/home'])
    return of(false)
  }

  return authService.user$.pipe(
    switchMap(() => {
      return userStore.getOneSelf({ useCache: true }).pipe(
        switchMap((user) => {
          if (!isFeatureAllowed('TRYGROUP_DASHBOARD', user.enabledFeatures)) {
            router.navigate(['/home'])
            return of(false)
          }

          if (user.roles.some((role) => role.code === 'SUPER_ADMIN')) {
            return of(true)
          }

          return trygroupDashboardSettingsService.canAccessDashboard().pipe(
            map((canAccess) => {
              if (!canAccess) {
                router.navigate(['/home'])
                return false
              }

              if (targetUserId === user.id) {
                return true
              }

              if (!hasTrygroupManagementRole(user)) {
                router.navigate(['/home'])
                return false
              }

              return true
            }),
          )
        }),
      )
    }),
  )
}
